import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message, Modal, Select, notification } from "antd";
import { updateBookingTour } from "../../../api/booking.service";
import { getTourPackages } from "../../../api/tour-package.service";

const { Option } = Select;

const EditTourBookingPackageModal = ({
    vehicleData,
    onClose,
    fetchVehicles,
    isModalOpen,
    setIsModalOpen,
    handleOk,
    handleCancel,
    isViewOnly = false,
}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                name: vehicleData.name,
                email: vehicleData.email,
                phone: vehicleData.phone,
                selectedPackage: vehicleData.selectedPackage.id, // assumes value matches one of the dropdown options
                status: vehicleData.status,
            });
        }
    }, [vehicleData, form]);

    const [tourPackages, setTourPackages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);


    const fetchPackages = async () => {
        try {
            setLoading(true);
            const data = await getTourPackages();
            setTourPackages(data?.data || []); // Set the fetched tours data
        } catch (err) {
            notification.error({ message: 'Failed to fetch tours' });
            setError('Failed to fetch tours');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPackages()
    }, [])

    const onFinish = async (values) => {
        try {
            await updateBookingTour(vehicleData.referenceNo, values);
            message.success("Booking updated successfully!");
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            message.error(error.message);
            console.error("Error:", error);
        }
    };

    return (
        <Modal
            className="vt-modal"
            footer={null}
            destroyOnClose
            title={`${isViewOnly ? "View" : "Edit"} Tour Booking`}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            onClose={handleCancel}
        >
            <Form
                disabled={isViewOnly}
                layout="vertical"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[
                                { required: true, message: "Please enter the customer's name" },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: "Please enter the customer's email" },
                                { type: "email", message: "Please enter a valid email" },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Phone"
                            name="phone"
                            rules={[
                                { required: true, message: "Please enter the customer's phone" },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Status"
                            name="status"
                            rules={[{ required: true, message: "Please select a status" }]}
                        >
                            <Select>
                                <Option value="CONFIRMED">Confirmed</Option>
                                <Option value="PENDING">Pending</Option>
                                <Option value="CANCELLED">Cancelled</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Selected Package"
                            name="selectedPackage"
                            rules={[
                                { required: true, message: "Please select a package" },
                            ]}
                        >
                            <Select placeholder="Select a package" options={tourPackages?.map((pkg)=>{
                                return {
                                    label: pkg.name,
                                    value: pkg.id
                                }
                            }) || []} />
                        </Form.Item>
                    </Col>
                </Row>

                {!isViewOnly && (
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                        <Button
                            style={{ marginLeft: 8 }}
                            onClick={() => setIsModalOpen(false)}
                        >
                            Cancel
                        </Button>
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default EditTourBookingPackageModal;
